<template>
  <v-layout column v-if="currentSection">
    <sx-html :text="currentSection.custom_element" />
  </v-layout>
</template>

<script>
import isEmpty from 'lodash/isEmpty';
import { mapGetters } from 'vuex';
import moment from 'moment';
import SxHtml from '@/components/sx/SxHtml';

export default {
  components: {
    SxHtml,
  },
  props: {
    currentQuestionnaire: {
      type: Object,
    },
    currentSection: {
      type: Object,
    },
  },

  data() {
    return {};
  },
  computed: {
    ...mapGetters({
      currentUser: 'user',
      currentFirm: 'currentFirm',
    }),
  },
  methods: {
    isEmpty,

    moment,
  },
};
</script>

<style lang="postcss" scoped></style>
